// extracted by mini-css-extract-plugin
export default {"speakButton":"speakButton_speakButton__4d6j0","speakButtonSlow":"speakButton_speakButtonSlow__HQGO7"};